import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaWhatsapp,
} from "react-icons/fa";
import { motion } from "framer-motion";
import Popup from "../components/Popup";

const Contact = () => {
  return (
    <section className="bg-[#d9f0ea] py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4">

        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
       
          <h1 className="text-4xl font-bold text-gray-800 mt-1">
            Get in Touch With Us
          </h1>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">

          {/* Left Cards Section */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={{
              hidden: {},
              visible: {
                transition: {
                  staggerChildren: 0.15,
                },
              },
            }}
            className="grid sm:grid-cols-2 gap-6"
          >

            {/* Card */}
            {[
                 {
  icon: <FaMapMarkerAlt />,
  title: "Office Address",
  text: (
    <>
      17, Naveen Park <br />
      Shyam Park, Sahibabad <br />
      Ghaziabad, 201005 <br />
      Uttar Pradesh, India
    </>
  ),
},
              {
                icon: <FaPhoneAlt />,
                title: "Call Us",
                text: "+91 9582730030",
              },
              {
                icon: <FaEnvelope />,
                title: "Email Us",
                text: "pcenterprises25@gmail.com",
              },
               {
    icon: <FaWhatsapp />,
    title: "WhatsApp",
    text: (
      <a
        href="https://wa.me/919582730030"
        target="_blank"
        rel="noopener noreferrer"
        className="text-green-600 font-medium hover:underline"
      >
        Chat on WhatsApp
      </a>
    ),
  },

             
            ].map((item, index) => (
              <motion.div
                key={index}
                variants={{
                  hidden: { opacity: 0, y: 40 },
                  visible: { opacity: 1, y: 0 },
                }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                whileHover={{ y: -6 }}
                className="bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all text-center"
              >
                <motion.div
                  whileHover={{ scale: 1.15 }}
                  transition={{ type: "spring", stiffness: 300 }}
                  className="text-4xl text-green-600 mx-auto mb-4 flex justify-center"
                >
                  {item.icon}
                </motion.div>

                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  {item.title}
                </h3>

                <p className="text-gray-600 text-sm whitespace-pre-line">
                  {item.text}
                </p>
              </motion.div>
            ))}
          </motion.div>

          {/* Right Form Section */}
          <motion.div
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
            className="bg-white rounded-2xl shadow-xl"
          >
            <Popup mode="page" />
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default Contact;